// extracted by mini-css-extract-plugin
module.exports = {"onestop":"onestop_onestop__3c1dh","useflex":"onestop_useflex__2-9LW","basket":"onestop_basket__1gQd9"};